// Import Packages
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { getExtension } from "../../../../helpers/helper";
import SettingsService from "../../../../services/SettingsService/SettingsService";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../recoil-store/recoil-state';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import "./Port.css";
import FieldLabel from '../../../../components/FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description This function lets you return Logging.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Port(props) {
    const { t } = useTranslation();
    const label = "CONTENT.SETTINGS.PORT.";
    const [file, setFile] = useState();
    //const [password, setPassword] = useState();
    const [updateFields, setUpdateFields] = useState({});
    const [loading, setLoading] = useState(false);

    const [formFields, setFormFields] = useState({
        // httpPort: "",
        // serviceHttpPort: "",
        // isHttps: true,
        validate: false,
        httpsPort: "",
        serviceHttpsPort: "",
        sslCertPassword: "",
        sslCertName: "",
        serviceHostName: ""
    });
    const [refresh, setRefresh] = useState(false);
    //const [serviceProtocol, setServiceProtocol] = useState("https://");
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        fetchData();
    }, [refresh]);

    async function fetchData() {
        const response = await SettingsService.getSettings();
        if (response && response.status) {
            if (response.code === 200) {
                let hostName;
                if (response.data.service_host_name) {
                    const uri = response.data.service_host_name.split('://');
                    //setServiceProtocol(uri[0] + "://");
                    hostName = uri[1];
                }

                const fields = {
                    // httpPort: response.data.http_port,
                    httpsPort: response.data.https_port,
                    // serviceHttpPort: response.data.service_http_port,
                    serviceHttpsPort: response.data.service_https_port,
                    //mateAgentPort: response?.data.ma_port,
                    sslCertName: response.data.ssl_cert_name ? response.data.ssl_cert_name : "",
                    validate: response.data.ssl_cert_name ? true : false,//response.data.ssl_enabled === '1',
                    // isHttps: true,//response?.data.ssl_enabled ? true : formFields.isHttps,
                    serviceHostName: hostName
                }

                if (response?.data.ssl_cert_name) {
                    const fileName = { name: response?.data.ssl_cert_name }
                    setFile({ ...file, ...fileName })
                }

                //setPassword(response?.data.ssl_cert_password);
                setFormFields(formFields => ({ ...formFields, ...fields }));
                setRefresh(true);
                setUpdateFields({});
            } else {
                restoreDefault();
            }
        }
    }

    const handleFileChange = (e) => {
        if (e.target.files[0]?.name) {
            let extension = getExtension(e.target.files[0]?.name);
            if (extension === "pfx") {
                setFile(e.target.files[0]);
            }
        }
        setStateField(false, "validate");
    };

    const fieldMatcher = (param) => {
        const fields = {
            "httpPort": "http_port",
            "httpsPort": "https_port",
            "serviceHttpPort": "service_http_port",
            "serviceHttpsPort": "service_https_port",
            "serviceHostName": "service_host_name"
        };

        return fields[param];
    }

    const handleUpdateFields = (value, param) => {
        const paramName = fieldMatcher(param);
        if (formFields[param] !== value) {
            updateFields[paramName] = value;
            setUpdateFields(updateFields)
        } else {
            delete updateFields[paramName];
            setUpdateFields(updateFields);
        }
    }

    const setStateField = (value, param) => {
        const field = { [param]: value }
        // if (param === "sslCertPassword")
        //     field.validate = false;
        setFormFields({ ...formFields, ...field });
        handleUpdateFields(value, param);
    }

    const handleChange = (e) => {
        setStateField(e.target.checked, "isHttps");
        if (e.target.checked) {
            handleUpdateFields(formFields.httpsPort, "httpsPort");
            handleUpdateFields(formFields.serviceHttpsPort, "serviceHttpsPort");
        } else {
            handleUpdateFields(formFields.httpPort, "httpPort");
            handleUpdateFields(formFields.serviceHttpPort, "serviceHttpPort");
        }
    };

    const handleClick = (e) => {
        setFile("");
        setStateField(false, "validate");
    };

    const validateForm = () => {
        return !(!formFields.httpsPort || !formFields.serviceHttpsPort || !formFields.serviceHostName);
    };
    const handleLoading = () => {
        setLoading(false)
    }
    async function handleSave() {
        // save data
        const isValid = validateForm();

        if (isValid) {
            // if (formFields.isHttps) {
            //     delete updateFields["http_port"];
            //     delete updateFields["service_http_port"];
            // } else {
            //     delete updateFields["https_port"];
            //     delete updateFields["service_https_port"];
            // }

            // setLoading(true)
            updateFields.service_host_name = "https://" + formFields.serviceHostName;
            updateFields.https_port = formFields.httpsPort;
            updateFields.service_https_port = formFields.serviceHttpsPort;
            // const res = await SettingsService.healthCheck(`${updateFields.service_host_name}:${servicePort}`)
            // handleLoading()
            // if (!res?.status) {
            //     setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.CREDENTIAL." + "HOST-NAME-NOT-FOUND"), severity: 'error' }));
            //     return
            // }

            // if (file && formFields.sslCertPassword !== password && !formFields.validate) {
            //     setAlert(alert => ({
            //         ...alert,
            //         show: true,
            //         message: t('MESSAGES.SETTINGS.PLEASE-VALIDATE-CERTIFICATE'),
            //         severity: 'error'
            //     }));
            //     return false;
            // }

            const response = await SettingsService.updateSettings(updateFields);

            if (response) {
                if (response.status) {
                    //success
                    setRefresh(true);
                }
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: response.message.includes('System Error:') ? response.message : t('MESSAGES.SETTINGS.' + response.message),
                    severity: response.status ? 'success' : 'error'
                }));
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.GENERAL.NETWORK-ERROR'),
                    severity: 'error'
                }));
            }

        } else {
            // Fields Empty message!
            setAlert(alert => ({ ...alert, show: true, message: t("GENERAL.NOT-NULL"), severity: 'error' }));
        }
    }

    async function handleValidateSSL() {
        if (!file.type) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.SETTINGS.VALIDATION-FAILED'),
                severity: 'error'
            }));
            setStateField(false, "validate");
            return
        }
        if (file?.name?.length) {
            const data = {
                file,
                password: formFields.sslCertPassword,
            };
            const response = await SettingsService.validateSslSettings(data);
            if (response) {
                if (response?.status) {
                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t('MESSAGES.SETTINGS.' + response.message),
                        severity: 'success'
                    }));
                    setStateField(response.status, "validate");
                } else {
                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t('MESSAGES.SETTINGS.' + response.message),
                        severity: 'error'
                    }));
                    setStateField(response.status, "validate");
                }
            }
        } else {
            // Fields Empty message!
            setAlert(alert => ({ ...alert, show: true, message: t("GENERAL.NOT-NULL"), severity: 'error' }));

        }
    }

    const restoreDefault = () => {
        const fields = {
            validate: false,
            httpsPort: "443",
            serviceHttpsPort: "2096",
            sslCertPassword: "",
            sslCertName: "",
            serviceHostName: ""
            // serviceHostName: ""
        }
        setFormFields(formFields => ({ ...formFields, ...fields }));
        setUpdateFields({
            https_port: "443",
            service_https_port: "2096",
            //ssl_enabled: false,
            service_host_name: ""
        })
    }

    return (
        <div className="port-ssl-container">
            <span className="header"> {t(label + "PORT-AND-SSL")}</span>
            <hr className="seperator header-seperator" />
            <div className="ssl-row">
                <div className="ssl-title">
                    {t(label + "SSL-TITLE")}
                </div>
                <div className="ssl-description">
                    {t(label + "SSL-DESCRIPTION")}
                </div>
                <hr className="seperator top-seperator" />

                <div className="ssl-file-container">

                    <div className="h-43 w-250">
                        <FieldLabel classes={"sub-header"} name={t(label + "SSL-CERTIFICATE")} />
                        <div className="custom-file config-form">
                            <span className="ssl-file-value-label">{file?.name ? file?.name : t(label + "NO-FILE-SELECTED")} </span>
                            <input
                                type="file"
                                accept=".pfx"
                                className="custom-file-input"
                                id="sgeneral-customFile"
                                onChange={handleFileChange}
                            />
                            {file?.name ?
                                <button
                                    onClick={handleClick}>&#x02A2F;
                                </button>
                                :
                                <label
                                    className="custom-file-label content-overflow"
                                    htmlFor="sgeneral-customFile"
                                >
                                    {t(label + "CHOOSE")}
                                </label>
                            }
                        </div>
                    </div>
                    <div>
                        <FieldLabel classes={"sub-header"} name={t(label + "PASSWORD")} />
                        <input
                            className="port-input h-43 "
                            type="password"
                            onChange={(e) => setStateField(e.target.value, "sslCertPassword")}
                            placeholder="******"
                        />
                    </div>
                </div>
                <hr className="seperator bottom-seperator" />
                <div className="port-ssl">
                    <div className="ssl-button-container">
                        <button
                            onClick={handleValidateSSL}
                            className={`import-ssl-button ${file?.name ? "active-import-button" : "disabled-import-button"}`}
                        >
                            {t(label + "IMPORT-SSL")}
                        </button>
                    </div>

                </div>

            </div>
            <div className="port-row">
                <div className="ssl-title">
                    {t(label + "PORT-TITLE")}
                </div>
                <div className="ssl-description">
                    {t(label + "PORT-DESCRIPTION")}
                </div>
                <hr className="seperator top-seperator" />
                <div className="port-grid">
                    <div>
                        <FieldLabel classes={"sub-header"} name={t(label + "HOST-NAME")} is_required />
                        <FormControl variant="outlined" className="host-name-container">
                            <div className="protocol-container">
                                <Select
                                    className="protocol"
                                    disabled={true}
                                    value="https://"
                                    native
                                    inputProps={{
                                        name: 'age',
                                        id: 'outlined-age-native-simple',
                                    }}
                                >
                                    <option style={{ background: "blue" }} value={"https://"}>https://</option>
                                </Select>
                                <input placeholder="autommate.com.tr" className="port-input host-name"
                                    onChange={(e) => setStateField(e.target.value, "serviceHostName")}
                                    value={formFields.serviceHostName ? formFields.serviceHostName : ""} />
                            </div>

                        </FormControl>
                    </div>


                    <div>
                        <FieldLabel classes={"sub-header"} name={t(label + "WEB")} is_required />
                        <input
                            placeholder="XXXX"
                            className="port-input"
                            type="number"
                            // onChange={(e) => setStateField(e.target.value, formFields.isHttps ? "httpsPort" : "httpPort")}
                            // value={formFields.isHttps ? formFields.httpsPort : formFields.httpPort}
                            onChange={(e) => setStateField(e.target.value, "httpsPort")}
                            value={formFields.httpsPort}
                            min="0"
                        />
                    </div>
                    <div>
                        <FieldLabel classes={"sub-header"} name={t(label + "TRIGGER-PORT")} is_required />
                        <input
                            placeholder="XXXX"
                            className="port-input"
                            type="number"
                            min="0"
                            // onChange={(e) => setStateField(e.target.value, formFields.isHttps ? "serviceHttpsPort" : "serviceHttpPort")}
                            // value={formFields.isHttps ? formFields.serviceHttpsPort : formFields.serviceHttpPort}
                            onChange={(e) => setStateField(e.target.value, "serviceHttpsPort")}
                            value={formFields.serviceHttpsPort}
                        />
                    </div>
                </div>
                <div className="sgeneral-divider bottom-seperator" />

                <div className="bottom-row">
                    <div className="footer-accept-buttons">
                        <button className={`button-save ${loading ? "disabled-input" : ""}`} disabled={loading} onClick={handleSave} >
                            {t(label + "SAVE")}
                        </button>
                    </div>
                    <button className="button-restore" onClick={restoreDefault}>
                        {t(label + 'RESTORE')}
                    </button>
                </div>
            </div>
        </div >
    );
}

export default Port;
